import React, { useContext } from 'react';
import pt from 'prop-types';
import Image, { imageProptypes } from '../../../../ui/image';
import Video, { videoPropTypes } from '../../../../ui/video';
import RichText, { richTextPropTypes } from '../../../../ui/richText';
import { combine } from '../../../../../helpers/styles';
import Link, { linkProptypes } from '../../../../ui/link';
import Text from '../../../../ui/text';
import * as styles from './styles.module.scss';
import { MicrocopyContext } from '../../../../../context/microcopy.context';
import { getCopy } from '../../../../../helpers/copy';

const TextVisualColumn = ({
  backgroundColor,
  link,
  media,
  articleType,
  textVisualSubline,
  textVisualText,
  imgClass,
  podcastId,
  className,
}) => {
  const microcopy = useContext(MicrocopyContext);
  const fontSize = imgClass?.includes('small') ? 'h4' : 'h3';

  const renderItem = () => (
    <div
      className={combine(
        styles.wrapper,
        styles[backgroundColor],
        !articleType || (articleType === 'None' && styles.withoutArticletype),
        className
      )}
    >
      {podcastId ? (
        <div className={combine(styles.podcast)}>
          <iframe
            src={`https://share.transistor.fm/e/${podcastId}`}
            width="100%"
            height="100%"
            frameborder="no"
          ></iframe>
        </div>
      ) : (
        media &&
        media.internal && (
          <div
            className={combine(
              styles.mediaWrapper,
              !textVisualSubline && !textVisualText,
              imgClass && styles[imgClass],
              !articleType && styles.withoutArticleType
            )}
          >
            {media.internal.type === 'ContentfulImage' && (
              <Image {...media} className={styles.media} />
            )}
            {media.internal.type === 'ContentfulVideo' && (
              <Video
                video={media}
                poster={media.poster}
                className={styles.media}
              />
            )}
          </div>
        )
      )}
      {articleType && articleType !== 'None' && (
        <Text type="p3" variant="light" className={styles.articleType}>
          {getCopy(`articleType.${articleType?.replace(/\s/g, '')}`, microcopy)}
        </Text>
      )}
      {textVisualSubline && (
        <Text as={fontSize} type={fontSize} className={styles.subline}>
          {textVisualSubline}
        </Text>
      )}
      {textVisualText && (
        <RichText
          content={textVisualText}
          textClassName={styles.textVisualText}
        />
      )}
    </div>
  );

  if (link)
    return (
      <Link link={link} className={combine(styles.link)}>
        {renderItem()}
      </Link>
    );

  return renderItem();
};

export const TextVisualColumnPropTypes = {
  backgroundColor: pt.oneOf(['none', 'beige', 'red', 'blue']),
  link: pt.shape(linkProptypes),
  media: pt.oneOfType([pt.shape(videoPropTypes), pt.shape(imageProptypes)]),
  articleType: pt.string,
  textVisualSubline: pt.string,
  textVisualText: pt.shape(richTextPropTypes),
  className: pt.string,
};

TextVisualColumn.propTypes = TextVisualColumnPropTypes;

TextVisualColumn.defaultProps = {
  backgroundColor: 'none',
  articleType: '',
  textVisualSubline: '',
  className: '',
};

export default TextVisualColumn;
